import CogniteLogoIcon from '#assets/cognite-logo-icon.svg?react';

export function CogniteLogo() {
  return <CogniteLogoIcon fill="white" />;
}
